import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import Footer from "../components/footer"
import { Switch } from "antd"
import { FaHospitalAlt, FaBriefcaseMedical } from "react-icons/fa"
import { MdOutlineCardTravel } from "react-icons/md"
import { BsCoin } from "react-icons/bs"
import { AiFillClockCircle, AiOutlineStar } from "react-icons/ai"
import { FiUsers } from "react-icons/fi"
import { Link } from "react-router-dom"
import { Pagination } from "antd"


const InterestedJobsPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const interestedJobsLength = [1, 2]

    const onShowSizeChange = (current, pageSize) => {
        console.log(current, pageSize);
    };

    return (
        <Navbar active={"jobs"} navShow={navShown}>
            <div>
                <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                    <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                    <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                        X
                    </span>
                    <h1 className="text-center text-white py-4 w-full font-bold">Interested Jobs</h1>
                </div>
                <div className="px-6 lg:px-7 relative top-20 text-[14px]">
                    <div className="">
                        These are jobs that you've expressed interest in.
                        <hr className="my-2" />
                    </div>
                    <div className="flex items-center gap-x-2">
                        <span>Only show the interested jobs that have been recommended to me</span>
                        <Switch onChange={(e) => console.log(e)} className="bg-gray-200" />
                    </div>

                    <div className="flex gap-5 justify-center mt-4 flex-wrap pb-36 ">
                        {
                            interestedJobsLength?.map((val, i) => {
                                return (
                                    <div key={i}>
                                        <span className="block mb-2 ml-2 font-semibold">Interested 5/27/23</span>
                                        <div className="p-4 flex flex-col justify-between gap-y-3 w-[280px] lg:w-[480px] rounded-lg" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                                            <span className="block uppercase font-medium text-xs">
                                                seattle, washington
                                            </span>
                                            <div>
                                                <div className="flex items-center gap-x-2">
                                                    <FaHospitalAlt className="text-gray-600" />
                                                    <p className="font-semibold">Harborview Medical Center</p>
                                                </div>
                                                <div className="flex items-center gap-x-2">
                                                    <MdOutlineCardTravel className="text-gray-600" />
                                                    <p className="">Travel</p>
                                                </div>
                                                <div className="flex items-center gap-x-2">
                                                    <FaBriefcaseMedical className="text-gray-600" />
                                                    <p className="">ICU</p>
                                                </div>
                                                <div className="flex items-center gap-x-2">
                                                    <AiFillClockCircle className="text-gray-600" />
                                                    <p className="">4 X 12 Night</p>
                                                </div>
                                                <div className="flex items-center gap-x-2">
                                                    <BsCoin className="text-gray-600" />
                                                    <p className="">$3234.79 to $3398.07 weekly</p>
                                                </div>
                                                <div className="flex items-center gap-x-2">
                                                    <FiUsers className="text-gray-600" />
                                                    <p className="">1 Opening</p>
                                                </div>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <div className="flex items-center gap-x-2 bg-cyan-100 w-fit px-2 py-1 rounded">
                                                    <AiOutlineStar className="text-gray-600 text-lg" />
                                                    <p className="">Aya advantage</p>
                                                </div>
                                                <Link to={"/job-details"} className="underline uppercase text-xs font-medium">View Job</Link>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                </div>


                <div className="fixed bottom-0 w-full">
                    <Pagination
                        onShowSizeChange={onShowSizeChange}
                        defaultCurrent={3}
                        total={500}
                        className="w-full bg-white"
                        showQuickJumper={false}
                        showSizeChanger={false}
                    />
                    <Footer />
                </div>
            </div>
        </Navbar>
    )
}

export default InterestedJobsPage